module.exports = __webpack_public_path__ + "fonts/XTypewriter-Bold.07e2620.otf";